import type { RuleGraphNode } from "@intelligems/ig-types/dtos/agentic-logic/rule-graph";

export const ruleLaneDelay = (
  node: RuleGraphNode | undefined,
  laneOrder: readonly string[]
): number => {
  if (node?.kind === "fallback-terminal") {
    return laneOrder.length * 0.06;
  }
  return (
    Math.max(0, laneOrder.indexOf(node?.branchId ?? node?.id ?? "")) * 0.06
  );
};
